import api from './api';

export type UserRole = 'admin' | 'manager' | 'employee';

export interface User {
  id: string;
  email: string;
  name: string;
  companyId?: string;
  role: UserRole;
  payRateDay?: number;
  taxCode?: string;
  socialSecurityNumber?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateUserData {
  email: string;
  password: string;
  name: string;
  role: UserRole;
  payRateDay?: number;
  taxCode?: string;
  socialSecurityNumber?: string;
}

export interface UpdateUserData {
  name?: string;
  role?: UserRole;
  payRateDay?: number;
  taxCode?: string;
  socialSecurityNumber?: string;
}

export const usersApi = {
  getAll: async (): Promise<User[]> => {
    const response = await api.get('/users');
    return response.data.data;
  },

  create: async (data: CreateUserData): Promise<User> => {
    const response = await api.post('/users', data);
    return response.data.data;
  },

  update: async (id: string, data: UpdateUserData): Promise<User> => {
    const response = await api.put(`/users/${id}`, data);
    return response.data.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/users/${id}`);
  },
};







